export const COMPONENT_INIT = 'COMPONENT_INIT';
export const MENU_OPENING = 'MENU_OPENING';
export const MENU_OPENED = 'MENU_OPENED';
export const MENU_CLOSING = 'MENU_CLOSING';
export const MENU_CLOSED = 'MENU_CLOSED';
export const PROGRAMMATIC_SCROLL_START = 'PROGRAMMATIC_SCROLL_START';
export const PROGRAMMATIC_SCROLL_END = 'PROGRAMMATIC_SCROLL_END';
export const UPDATE_PAGE_HEADER_THEME = 'UPDATE_PAGE_HEADER_THEME';
export const THEME_UPDATED = 'THEME_UPDATED';
